import Model from '@ember-data/model';

export default class FlowVersionModel extends Model {
  // Minimal model for flow version tracking
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'flow-version': FlowVersionModel;
  }
}
